var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoPlusBegradigt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 76,
    viewBox: "0 0 74 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1E4A87",
    fillRule: "nonzero",
    d: "M7.81,6.97 L59.92,6.97 C64.01,6.97 67.33,10.29 67.33,14.38 L67.33,66.49 C67.33,70.58 64.01,73.9 59.92,73.9 L7.81,73.9 C3.72,73.9 0.4,70.58 0.4,66.49 L0.4,14.38 C0.4,10.29 3.72,6.97 7.81,6.97"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.544,
    d: "M7.81,6.97 L59.92,6.97 C64.01,6.97 67.33,10.29 67.33,14.38 L67.33,66.49 C67.33,70.58 64.01,73.9 59.92,73.9 L7.81,73.9 C3.72,73.9 0.4,70.58 0.4,66.49 L0.4,14.38 C0.4,10.29 3.72,6.97 7.81,6.97 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M36.2,12.45 C43.3070173,12.45 48.7799549,14.0421273 52.6074573,17.2437089 C56.4853473,20.4305919 58.42,24.9912131 58.42,30.89 C58.42,36.7978899 56.4825606,41.3822171 52.608974,44.6050398 C48.8796746,47.6944593 43.5966219,49.2734441 36.7722641,49.3565379 L36.2,49.36 L27.35,49.36 L27.35,68.43 L12.17,68.43 L12.17,12.45 L36.2,12.45 Z M34.69,22.71 L26.35,22.71 L26.35,39.07 L34.69,39.07 L35.0769551,39.0656713 C37.7582966,39.0050558 39.8653174,38.3075251 41.3917172,36.9541172 C43.0070066,35.5003753 43.81,33.4634486 43.81,30.87 C43.81,28.2842327 43.005425,26.2567037 41.3917172,24.8258828 C39.7926317,23.4080269 37.5563114,22.71 34.69,22.71 L34.69,22.71 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E4A87",
    fillRule: "nonzero",
    d: "M63.91,19.31 C69.13,19.31 73.37,15.03 73.37,9.75 C73.37,4.47 69.14,0.19 63.91,0.19 C58.69,0.19 54.45,4.47 54.45,9.75 C54.45,15.03 58.69,19.31 63.91,19.31"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.91,
    cy: 9.76,
    stroke: "#FFF",
    strokeWidth: 0.544,
    rx: 9.46,
    ry: 9.56
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    fillRule: "nonzero",
    points: "68.82 8.63 65.15 8.63 65.15 4.66 62.65 4.66 62.65 8.63 59 8.63 59 10.86 62.65 10.86 62.65 14.85 65.15 14.85 65.15 10.86 68.82 10.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#FFF",
    strokeWidth: 0.544,
    points: "68.82 8.63 65.15 8.63 65.15 4.66 62.65 4.66 62.65 8.63 59 8.63 59 10.86 62.65 10.86 62.65 14.85 65.15 14.85 65.15 10.86 68.82 10.86"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPlusBegradigt);
export default __webpack_public_path__ + "static/media/ico_plus_begradigt.09dbb8cf04779b966523253071767c09.svg";
export { ForwardRef as ReactComponent };